import React, { useState } from "react";
import { EquipmentV2Label } from "../../../utils/labels";
import * as ContentStyles from "../styles/EquipmentContent";
import { trackEquipmentDescriptionToggle } from "../../../utils/tracking";
import { useEquipmentV2Selector } from "../../../redux/store";

type EquipmentDescriptionType = {
    description: string;
    categoryId: string; // necessary for tracking
    categoryName: string; // necessary for tracking
    equipmentId: string; // necessary for tracking
    equipmentName: string; // necessary for tracking
};

const EquipmentDescription = (props: EquipmentDescriptionType): JSX.Element => {
    const { description, categoryId, categoryName, equipmentId, equipmentName } = props;
    const componentName = useEquipmentV2Selector((state) => state.commonSettings.component);
    const [isOpen, setIsOpen] = useState(false);

    const toggle = (): void => {
        setIsOpen(!isOpen);
        trackEquipmentDescriptionToggle(componentName, categoryId, categoryName, equipmentId, equipmentName);
    };

    return (
        <>
            <ContentStyles.Header onClick={toggle}>
                <EquipmentV2Label label="equipmentMoreInformation" />
            </ContentStyles.Header>
            <ContentStyles.Toggle isOpen={isOpen}>{description}</ContentStyles.Toggle>
        </>
    );
};

export default EquipmentDescription;
